import { Link  } from "react-router-dom"; 
import {FcMoneyTransfer, FcOrgUnit} from "react-icons/fc";
import {BsCashStack} from "react-icons/bs";
import HandleCurrentPath from "./HandleCurrentPath";

const Menu = () =>{

  const pathname = window.location.pathname;
 
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>

        <ul>

         


<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/deposit'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/deposit'} >
         <FcMoneyTransfer/>
         <span className="ml-4">Deposits </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/winning'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/winning'} >
         <BsCashStack/>
         <span className="ml-4">Winnings </span>
     </Link>
</li>
 

  
  </ul>
        </>
    );
}
export default Menu;